import objectFitImages from 'object-fit-images';
import Cookie from 'js.cookie';

export default {
  init() {
    // JavaScript to be fired on all pages
    objectFitImages();
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    // toggles hamburger and nav open and closed states
    var removeClass = true;
    $('.hamburger').click(function () {
      $('.hamburger').toggleClass('is-active');
      $('#sideNav').toggleClass('sideNav-open');
      $('.sideNavBody').toggleClass('sideNavBody-push');
      removeClass = false;
    });

    $('.sideNav').click(function() {
      removeClass = false;
    });

    document.addEventListener('touchstart', function(e) {
      if (removeClass && !$(e.target).hasClass('sideNav') && $('.sideNav').has($(e.target)).length === 0) {
        $('.hamburger').removeClass('is-active');
        $('#sideNav').removeClass('sideNav-open');
        $('.sideNavBody').removeClass('sideNavBody-push');
      }
      removeClass = true;
    }, false);

    $(window).scroll(function () {
      if ($(this).scrollTop() > 100) {
        $('.scrollup').fadeIn();
      } else {
        $('.scrollup').fadeOut();
      }
    });

    $('.scrollup').click(function () {
      $('html, body').animate({
        scrollTop: 0,
      }, 600);
      return false;
    });

    if (!Cookie.get('alert') && $('#alertModal').length) {
      $('#alertModal').show();
    }
    
    $('.modal .btn-close').click(function() {
      $('#alertModal').hide();
      Cookie.set('alert', true, {
        expires: 1,
      });
    });

    if (!Cookie.get('nlp') && $('#nlpmodal').length) {
      $('#nlpmodal').show();
    }

    $('.nlp .btn-close').click(function() {
      $('#nlpmodal').hide();
      Cookie.set('nlp', true, {
        expires: 1,
      });
    });

    if ($('.testimonials-carousel').length) {
      $('.shorten-class').each(function() {
        var words = $(this).text().split(' ').filter(function(a) {return a});
        var maxWords = 40;
    
        if(words.length > maxWords) {
          var html = words.slice(0, maxWords).join(' ') + '<span class="show_more" style="display:none;"> ' + words.slice(maxWords, words.length).join(' ') + '</span>' + '<a href="#" class="read_more"><span>...</span> Read More </a>';
    
          $(this).html(html);
        }
      });

      $('.testimonials-carousel').click(function(event) {
        if ($(event.target).hasClass('read_more')) {
          $(event.target).toggleClass('less');
          event.preventDefault();
      
          if ($(event.target).hasClass('less')) {
            $(event.target).html('<br/>Read Less');
            $(event.target).parent().find('.show_more').show(300);
            $('.testimonials-carousel').slick('resize');
          } else{
            $(event.target).html('<span>...</span> Read More');
            $(event.target).parent().find('.show_more').hide(300);
            $('.testimonials-carousel').slick('resize');
          }
        }
      });

      $('.testimonials-carousel').slick({
        slidesToShow: 3,
        slidesToScroll: 3,
        adaptiveHeight: true,
        appendArrows: '.testimonials-panel .slider-nav',
        appendDots: '.testimonials-panel .slider-nav',
        arrows: true,
        dots: true,
        responsive: [
          {
            breakpoint: 1440,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              arrows: true,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: false,
              arrows: true,
            },
          },
        ],
      });
    }

    $('.project-gallery').lightGallery({
      selector: '.project-gallery .gallery-image',
    });

    if ($('.woocommerce-cart .cross-sells ul.products').length) {
      $('.woocommerce-cart .cross-sells ul.products').slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 575,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js